module.exports = __webpack_public_path__ + "static/img/img_norder.b2fa56f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_norder.png
// module id = 364
// module chunks = 1